import * as types from "../constants/constants";

export const message = (data) => {
  return (dispatch) => {
    console.log('data: ', data);
    dispatch(addMessage(data));
  };
};

export const clearMessage = () => {
  return { type: types.TOASTMESSAGE_DATA_CLEAR,data:"" };
};
export const addMessage = (data) => {
  console.log('data: ', data);
  return { type: types.SIGNUP_DATA_FAIL, data };
};